module.exports = __webpack_public_path__ + "static/media/FolderYellowDark.ff9829ff.svg";